import { Pipe, PipeTransform } from '@angular/core';
import { Issue } from '../data/smart-devices.interface';

@Pipe({
  standalone: false,
  name: 'deviceIssuesTooltip',
})
export class DeviceIssuesTooltipPipe implements PipeTransform {
  transform(issues: Issue[]): any {
    if (!issues || !issues.length) {
      return '';
    }

    return issues.map((issue) => issue.message).join('\n');
  }
}
